import { request } from './client.js';
import { toQuery } from '../utils/params.js';

export const rulesApi = {
  // Pay-code rules
  listPayCodes: (params = {}) => request(`/api/rules/pay-codes${toQuery(params)}`),
  getPayCode:   (id) => request(`/api/rules/pay-codes/${id}`),
  createPayCode: (rule) =>
    request('/api/rules/pay-codes', { method: 'POST', body: JSON.stringify(rule) }),
  updatePayCode: (id, rule) =>
    request(`/api/rules/pay-codes/${id}`, { method: 'PUT', body: JSON.stringify(rule) }),
  patchPayCodeField: (id, field, value) =>
    request(`/api/rules/pay-codes/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ field, value }),
    }),
  bulkDeletePayCodes: (ids) =>
    request('/api/rules/pay-codes/bulk-delete', {
      method: 'POST', body: JSON.stringify({ ids }),
    }),

  // Holiday overrides
  listHolOverrides: (params = {}) => request(`/api/rules/hol-overrides${toQuery(params)}`),
  createHolOverride: (data) =>
    request('/api/rules/hol-overrides', { method: 'POST', body: JSON.stringify(data) }),
  patchHolOverrideField: (id, field, value) =>
    request(`/api/rules/hol-overrides/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ field, value }),
    }),
  bulkDeleteHolOverrides: (ids) =>
    request('/api/rules/hol-overrides/bulk-delete', {
      method: 'POST', body: JSON.stringify({ ids }),
    }),
  getOverridePayCategories: () => request('/api/rules/hol-overrides/pay-categories'),
  getOverrideSites:         () => request('/api/rules/hol-overrides/sites'),
  // Distinct pay categories Dayforce has sent (df.pay_summaries) — Add Rule dropdown
  getDistinctPayCategories: () => request('/api/rules/pay-categories/distinct'),
  getOverrideLaborMetrics:  (siteCode) =>
    request(`/api/rules/hol-overrides/labor-metrics?site_code=${siteCode}`),
};
